import { render, staticRenderFns } from "./Interior.vue?vue&type=template&id=0fb1f0cb&"
import script from "./Interior.vue?vue&type=script&lang=js&"
export * from "./Interior.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports